import { render, staticRenderFns } from "./deletePrivilegeGroup.vue?vue&type=template&id=3c36d502&scoped=true"
import script from "./deletePrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./deletePrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./deletePrivilegeGroup.vue?vue&type=style&index=0&id=3c36d502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36d502",
  null
  
)

export default component.exports